import { CmsPageResponse, getPage } from '@bepro-travel/fe.shared';
import React, { FC, useEffect, useState } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@bepro-travel/fe.ui';

interface CancellationPolicyModalProps {
  onClose: () => void;
}

const CancellationPolicyModal: FC<CancellationPolicyModalProps> = ({
  onClose,
}) => {
  const [data, setData] = useState<CmsPageResponse>();

  useEffect(() => {
    (async () => {
      const newData = await getPage('/pages/Privacy');

      if (newData) {
        console.log('newData', newData);
        setData(newData);
      }
    })();
  }, []);

  return (
    <div
      className="modal-overlay modal-overlay-top"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className={'modal modal-lg active'}>
        <div
          className="modal-title flex-between"
          style={{ padding: '10px 10px 5px', direction: 'rtl' }}
        >
          <FontAwesomeIcon icon={faTimes} onClick={onClose} />
        </div>
        <div
          className="modal-con"
          style={{
            maxHeight: 'calc(100% - 140px)',
            overflowY: 'auto',
            textAlign: 'right',
            padding: '0 20px',
          }}
        >
          {data?.pageItems?.map((content, index) => (
            <div
              style={{ order: content.orderDisplay }}
              key={index}
              className="main-page-section text-lh"
            >
              {!!content.pageContent?.desc && (
                <div className="title text-center mb-0 text-lg">
                  {content.pageContent?.desc}
                </div>
              )}

              {!!content.pageContent?.sub && (
                <div className="text-md text-center">
                  {content.pageContent?.sub}
                </div>
              )}
              <div
                dangerouslySetInnerHTML={{ __html: content.pageContent?.body }}
              ></div>
            </div>
          ))}
        </div>
        <div className="modal-footer flex-between">
          <Button
            title="סגור"
            className="btn btn-default"
            onClick={() => onClose()}
          />
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicyModal;
